module.exports = __webpack_public_path__ + "static/images/c7ae79ff9ccc776a6b3f2254deda7c4d.png";